import {IPaletteOptions} from "../interfaces/themes/ITheme";

export const DarkPalette: IPaletteOptions = {
	primary: {
		main: '#ff4f4f',
		light: '#FF8080',
		dark: '#ab3131',
		contrastText: "#222222",
	},
	secondary: {
		main: '#333333',
		light: '#D800FF',
		dark: '#D800FF',
		contrastText: "#D800FF"
	},
	text: {
		primary: '#DDDDDD',
		secondary: '#FFFFFF',
		tertiary: '#444444',
		quaternary: '#BBBBBB',
		disabled: '#D800FF',
		hint: '#D800FF',
	},
	shadow: {
		main: '-4px 4px 0px #ffffff44',
		hover: '-3px 3px 0px #ffffff44',
		inset: 'inset -2px 2px 0px #ffffff2f, inset 1px -1px 1px #ffffff2f',
	}
};
